import { Loader2 } from "lucide-react";
import type { Panneau as PanneauModel, PanneauDetail } from "../api/types";
import { usePanneau } from "../api/queries";
import { Panneau } from "./Panneau";

interface Props {
  conv: string;
  summary: PanneauModel;
  /** Threaded through to the Panneau so App can intercept the close
   *  click and drive the undo toast from a single source. */
  onArchive?: (panneau: PanneauDetail) => void;
}

export function PanneauContainer({ conv, summary, onArchive }: Props) {
  const detail = usePanneau(summary.id);

  if (detail.isLoading) {
    return (
      <div className="rounded-2xl border border-black/10 dark:border-white/10 bg-white dark:bg-surface-dark p-8 flex items-center justify-center text-muted dark:text-muted-dark">
        <Loader2 className="h-4 w-4 animate-spin mr-2" />
        Chargement…
      </div>
    );
  }
  if (!detail.data) {
    return (
      <div className="rounded-2xl border border-black/10 dark:border-white/10 bg-white dark:bg-surface-dark p-8 text-muted dark:text-muted-dark">
        Panneau introuvable.
      </div>
    );
  }

  return <Panneau conv={conv} panneau={detail.data} onArchive={onArchive} />;
}
